import { createAsyncThunk } from "@reduxjs/toolkit";
import { parseAndThrowPaymentError } from "@/lib/backend-error";
import { SetupIntentRequest, SetupIntentResponse } from "../types/setup-intent";
import {
  SetPaymentMethodRequest,
  SetPaymentMethodResponse,
} from "../types/set-payment-method";
import { t } from "i18next";

export const initiateCheckout = createAsyncThunk(
  "payment/initiateSetupIntent",
  async (data: SetupIntentRequest) => {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/api/setup-intent`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      parseAndThrowPaymentError(
        errorData,
        errorData?.message || t("errors.FAILED_TO_CREATE_SETUP_INTENT")
      );
    }

    return response.json() as Promise<SetupIntentResponse>;
  }
);

export const setPaymentMethod = createAsyncThunk(
  "payment/setPaymentMethod",
  async (data: SetPaymentMethodRequest) => {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/api/set-default-payment-method`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      parseAndThrowPaymentError(
        errorData,
        errorData?.message || t("errors.FAILED_TO_SET_PAYMENT_METHOD")
      );
    }

    return response.json() as Promise<SetPaymentMethodResponse>;
  }
);
